import { DialogWrapper } from 'components/dialogWrapper'
import { Loader } from 'components/loader'
import { Img } from 'components/image'
import { Dispatch, SetStateAction } from 'react'
import { useCollectionContent } from 'hooks/collection'

interface ViewCollectionDialogProps {
    isOpen: boolean
    setIsOpen: Dispatch<SetStateAction<boolean>>
    collectionData: any | null
}

const ViewCollectionDialog = ({
    isOpen,
    setIsOpen,
    collectionData,
}: ViewCollectionDialogProps) => {
    const { data: collectionContentData, isLoading } = useCollectionContent(
        collectionData?.id
    )
    if (!isOpen) return null

    const collection = collectionContentData?.data?.collection || {}
    const episodes = collectionContentData?.data.episodes || []

    return (
        <DialogWrapper
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            title="Engagement Details"
        >
            <div className="space-y-4 p-2">
                {/* ===========================
          SHOW INFORMATION
      =========================== */}
                <div className="p-4 rounded-lg">
                    {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <p className="text-sm text-gray-500">
                                {collection?.numberOfViews?.label ?? '—'}
                            </p>
                            <p className="font-medium">
                                {collection?.numberOfViews?.value ?? '—'}
                            </p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500">
                                {collection?.numberOfEpisodesWatched?.label ??
                                    '—'}
                            </p>
                            <p className="font-medium">
                                {collection?.numberOfEpisodesWatched?.value ??
                                    '—'}
                            </p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-500">
                                {collection?.durationOfEpisodesWatched?.label ??
                                    '—'}
                            </p>
                            <p className="font-medium">
                                {collection?.durationOfEpisodesWatched?.value ??
                                    '—'}
                            </p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-500">
                                {collection?.averageCompletionPercentage
                                    ?.label ?? '—'}
                            </p>
                            <p className="font-medium">
                                {collection?.averageCompletionPercentage
                                    ?.value ?? '—'}
                            </p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-500">
                                {collection?.averageScrollDepth?.label ?? '—'}
                            </p>
                            <p className="font-medium">
                                {collection?.averageScrollDepth?.value ?? '—'}
                            </p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500">
                                {collection?.returnVisits7Day?.label ?? '—'}
                            </p>
                            <p className="font-medium">
                                {collection?.returnVisits7Day?.value ?? '—'}
                            </p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-500">
                                {collection?.returnVisits30Day?.label ?? '—'}
                            </p>
                            <p className="font-medium">
                                {collection?.returnVisits30Day?.value ?? '—'}
                            </p>
                        </div>
                    </div> */}

                    <table className="w-full border border-gray-300 border-collapse rounded-lg">
                        <tbody>
                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {collection?.numberOfViews?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {collection?.numberOfViews?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {collection?.numberOfEpisodesWatched?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {collection?.numberOfEpisodesWatched?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {collection?.durationOfEpisodesWatched?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {collection?.durationOfEpisodesWatched?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {collection?.averageCompletionPercentage?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {collection?.averageCompletionPercentage?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {collection?.averageScrollDepth?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {collection?.averageScrollDepth?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {collection?.returnVisits7Day?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {collection?.returnVisits7Day?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {collection?.returnVisits30Day?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {collection?.returnVisits30Day?.value ?? '—'}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

                {/* ===========================
          EPISODES SECTION
      =========================== */}
                {/* Episodes (selected in Create Show) */}
                {/* Episodes Section */}
                <div className="flex justify-end pt-4">
                    <button
                        onClick={() => setIsOpen(false)}
                        className="px-4 py-2 bg-gray-200 rounded bg-gray-300 dark:bg-slate-700 text-gray-800 dark:text-slate-200
"
                    >
                        Close
                    </button>
                </div>
            </div>
        </DialogWrapper>
    )
}

export default ViewCollectionDialog
